import Api from './api';

const DiarioService = {


    listar: async (params) => {
        const response = await Api({
            method: 'get',
            url: '/diario/listar',
            params: params
        })
        return response
    },
    numDiarios: async (params) => {
        return Api({
            method: 'get',
            url: '/diario/numdiarios',
            params: params
        })
    },
    buscarExpo: async (params) => {
        return Api({
            method: 'get',
            url: '/diario/buscar-exposicao',
            params: params
        })
    },
    buscar: (params) => {
        const response = Api.get(`/diario/buscar?${params}`)
        return response
    }
}

export default DiarioService;